<template>
<div>
  <el-tooltip :placement="placement">
    <div slot="content" class="max-w-sm max-h-500p overflow-auto">
      {{ content }}
    </div>
    <span class="tooltip-icon__icon-wrap">
      <base-icon :size="size" :name="finalIcon" :custom="finalClass" class="w-10/5 h-10/5 cbutton--prim-phantom bg-primary-50 dark:bg-darkblue rounded-full" />
    </span>
  </el-tooltip>
</div>
</template>

<script>
const PLACEMENTS = ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end']

export default {
  name: 'tooltip-icon',
  props: {
    content: {
      type: String,
      default: 'info'
    },
    placement: {
      type: String,
      default: 'right',
      validator: value => PLACEMENTS.includes(value)
    },
    size: {
      type: String,
      default: 'md'
    },
    type: {
      type: String,
      default: 'info'
    },
    icon: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
  },
  computed: {
    finalClass: function () {
      return `${this.colorClass} ${this.customClass}`
    },
    finalIcon: function () {
      return this.icon || this.type
    },
    colorClass: function () {
      switch (this.type) {
        case 'success':
        case 'warning':
        case 'error':
        case 'none':
          return `base-icon-${this.type} hover:base-icon-${this.type} dark:base-icon-${this.type} dark:hover:base-icon-${this.type}`
      
        case 'info':
        default:
          return 'text-primary hover:text-primary-500 dark:hover:text-white hover:bg-primary-100 dark:hover:bg-primary-500'
      }
    }
  }
}
</script>
